// extracted by mini-css-extract-plugin
export var container = "_c5-0";
export var containerTopRight = "_c5-1";